import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      <header className="header">
        <Link to="/" className="logo">
          <img
            src={process.env.PUBLIC_URL + '/images/musa_logo.png'}
            alt="Musa Electrical"
            className="logo-image"
          />
          <div className="logo-text">
            <span className="logo-musa">Musa</span>
            <span className="logo-electrical">Electrical</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <ul className="nav-menu">
            <li><NavLink to="/" end>Home</NavLink></li>
            <li><NavLink to="/about">About</NavLink></li>
            <li><NavLink to="/services">Services</NavLink></li>
            <li><NavLink to="/projects">Projects</NavLink></li>
            <li><NavLink to="/blog">Blog</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
          </ul>
        </nav>

        <a href="tel:0796049254" className="contact-btn">📞 0796049254</a>

        {/* Hamburger Button */}
        <button
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Mobile Overlay */}
      <div className={`mobile-overlay ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(false)}></div>

      {/* Mobile Slide-in Menu */}
      <div className={`mobile-menu ${menuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <Link to="/" className="mobile-logo" onClick={() => setMenuOpen(false)}>
            <img
              src={process.env.PUBLIC_URL + '/images/musa_logo.png'}
              alt="Musa Electrical"
              className="mobile-logo-image"
            />
            <div className="mobile-logo-text">
              <span className="mobile-logo-musa">Musa</span>
              <span className="mobile-logo-electrical">Electrical</span>
            </div>
          </Link>
          <button className="close-btn" onClick={() => setMenuOpen(false)}>✕</button>
        </div>
        <nav className="mobile-nav">
          <ul>
            <li><NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink></li>
            <li><NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink></li>
            <li><NavLink to="/services" onClick={() => setMenuOpen(false)}>Services</NavLink></li>
            <li><NavLink to="/projects" onClick={() => setMenuOpen(false)}>Projects</NavLink></li>
            <li><NavLink to="/blog" onClick={() => setMenuOpen(false)}>Blog</NavLink></li>
            <li><NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink></li>
          </ul>
        </nav>
        <div className="mobile-menu-footer">
          <a href="tel:0796049254" className="mobile-call-btn">📞 Call 0796049254</a>
        </div>
      </div>
    </>
  );
};

export default Header;
